import React, { Suspense, useState } from "react";
import { ImageLink } from "../../../../utils/constants";
import { deleteItem } from "../../../../utils/apiUtils";
import { ActionButton } from "../../../../helper/ImageFormat";
import DeleteModel from "../../../../Components/DeleteModel";
import { useNavigate } from "react-router-dom";
const ProductListPreview = ({ products, callbackFunc,combinedattributeData ,catalogue_id,catalogueData}) => {
  const navigate=useNavigate()
 const [deleteItemId, setDeleteItemId] = useState(null);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [isDeleting, setIsDeleting] = useState(false);
 const handleEditClick = (data) => {
   navigate(`/catalogue-product/update`, {
             state: {
              id:catalogue_id,
              combinedattributeData: combinedattributeData,
              product_id:data?.id,
              catalogueData:catalogueData
             
             },
            });


 };

 const handleDelete = async (id) => {
  setDeleteItemId(id);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("catalogue-product", deleteItemId?.id, callbackFunc,);
   setDeleteItemId(null);
   setDeleteModalOpen(false);
   return res;
  } catch (err) {
   throw err;
  } finally {
   setIsDeleting(false);
  }
 };
console.log(products)
 return (
  <div className="col-12">
   <div className="rounded bg-white px-4 pt-4 pb-2 mb-3 shadow-sm">
    <h5 className="mb-3">Product Preview List</h5>

    {products.length === 0 ? (
     <p className="text-muted">No products added yet.</p>
    ) : (
     <div className="table-responsive">
      <table className="table table-striped">
       <thead>
        <tr>
         <th>#</th>
         <th>Image</th>
         <th>Name</th>
         <th>price</th>
         <th>FullSet/Single</th>
        </tr>
       </thead>
       <tbody>
        {products.map((product, index) => (
       <tr key={index}>
  <td>{index + 1}</td>
  <td>
    {product?.image && (
      <img
        src={ImageLink(product?.image?.[0])}
        alt="product"
        style={{ width: 50, height: 50, objectFit: "cover" }}
      />
    )}
  </td>
  <td>{product.name || ""}
   {product.outofStock && (
    <span
      className="badge bg-danger"
      style={{ fontSize: "10px", marginLeft: "8px",color:"#fff" }}
    >
      Out of Stock
    </span>
  )}

  </td>
  <td>{product.offer_price || 0}</td>
  <td>
    <span
      className="badge badge-dark"
      style={{ fontSize: "10px", marginLeft: "10px" }}
    >
      {product.showInSingle ? "Full Set + Selection" : "Full Set"}
    </span>
  </td>

  <td>
    <ActionButton
      data={product}
      handleEditClick={handleEditClick}
      handleDelete={handleDelete}
      module={"Catalogue"}
    />
  </td>
</tr>

        ))}
       </tbody>
      </table>
     </div>
    )}
   </div>

   <Suspense fallback={<div>Loading...</div>}>
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="Catalogue Product"
     isDeleting={isDeleting}
    />
   </Suspense>
  </div>
 );
};

export default ProductListPreview;
